import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { size } from "../../../shared/constants";
import { Row } from "../../Grid";
var HeaderRow = styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n"])), size.lg);
export { HeaderRow };